<template>
  <div class="relative mt-20 mb-20 max-w-screen-sm left-1/2 -translate-x-1/2">
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-12">
        <h2>Welcome <span class="font-bold">{{ userStore.user.name }}</span>!</h2>
        <p v-if="wait">We need 5 nights of sleep data to make your first recommendation 🤩</p>
        <p v-else>Nice, you already have sleep data 🤩</p>
      </div>
      <div v-if="wait" class="flex flex-col items-center px-12">
        <img src="@/assets/fire.png" class="w-16 m-4">
        <div class="grid grid-cols-5 w-full mb-8">
          <div v-for="d in days" :key="d">{{ d.day }}</div>
          <div v-for="d in days" :key="d">
            <span v-if="d.sleep">✔️</span>
          </div>
        </div>
        <CalloutComponent
          type='info'
        >
          Almost there! Track your sleep for {{ daysLeft }} more nights using Fitbit.
        </CalloutComponent>
      </div>
      <div v-else class="flex flex-col items-center">
        <div class="absolute top-1/2 z-10">{{ analysis }}</div>
        <svg v-if="loading" class="animate-spin h-36 w-36 m-8 text-teal-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <img v-else src="@/assets/tick.svg" class="h-36 w-36 m-8">
      </div>
      <!-- TODO: Make the button enable notifications for when there's not enough sleep data -->
      <LoadingButton
        v-if="!wait"
        :disabled='loading'
        :loading='buttonLoading'
        @action-function="goToNext"
      >
        Show insights →
      </LoadingButton>
    </div>
  </div>
</template>

<script>
import LoadingButton from '@/components/LoadingButton'
import CalloutComponent from '@/components/CalloutComponent'
import { getXDaysAgo, dateArray, isSameDate } from '@/helpers/time'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

const DAYS_DATA_REQUIRED = 5

export default {
  name: 'OnboardingAnalysis',
  components: {
    LoadingButton,
    CalloutComponent,
  },
  data() {
    return {
      buttonLoading: false,
      days: [],
      daysLeft: 0,
      wait: undefined,
      loading: true,
      analysis: 'Analysing sleep data...',
    }
  },
  beforeMount() {
    this.getData()
    this.loadAnalysis()
  },
  methods: {
    async getData() {
      // TODO: Change requirement to 5 days in the past week.
      const dates = getXDaysAgo(DAYS_DATA_REQUIRED - 1)
      const dateFrom = dates.start
      const dateTo = dates.end
      const sleeps = await this.userStore.user.getSleeps(dateFrom, dateTo, true)
      this.days = dateArray(dateFrom, dateTo)
      for (var i = 0; i < this.days.length; i++) {
        for (var j = 0; j < sleeps.length; j++) {
          if (isSameDate(this.days[i].date, sleeps[j].date)) {
            this.days[i].sleep = true
          }
        }
      }
      this.daysLeft = DAYS_DATA_REQUIRED - sleeps.length
      this.wait = sleeps.length < DAYS_DATA_REQUIRED
      // this.days[0].sleep = true
      // this.days[1].sleep = true
      // this.daysLeft = 3
      this.wait = false
    },
    async loadAnalysis() {
      const delay = ms => new Promise(res => setTimeout(res, ms))
      await delay(2500)
      this.analysis = 'Personalising recommendations...'
      await delay(2500)
      this.analysis = ''
      this.loading = false
    },
    goToNext() {
      this.$router.push('/onboarding/insights')
    },
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>